var _rect, _rect2, _rect3, _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolveesy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 50,
    viewBox: "0 0 204 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 50,
    fill: "#BABABA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "How it Works",
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7612,
    transform: "translate(-72 -54)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Solveeesy How It Works Page",
    clipPath: "url(#clip1_0_1)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 862,
    transform: "translate(-72 -54)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000010947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 44,
    height: 36
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bc06d79b73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 14H43.3371V50.0008H0V14Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.2262 36.3632L29.2411 39.9979L25.6324 42.6281L20.8817 39.1422L15.8557 35.4555L11.1384 31.9956L14.747 29.3654L19.4606 32.8252L24.4903 36.512L29.4755 32.8773L32.9278 30.3587L27.8981 26.672L24.4457 29.1906L19.7321 25.7308L14.747 22.0775L10.1488 18.7032L4.98512 14.916L0 18.5507L5.16369 22.3379L9.76191 25.7122L6.157 28.3386L1.14211 31.9956L6.12723 35.6526L10.8408 39.1087L15.8705 42.7955L20.6213 46.2814L25.5506 49.8974L30.5618 46.2442L34.1704 43.6102L39.1555 39.9793L42.6079 37.4607L37.6786 33.8446L34.2262 36.3632Z",
    fill: "#110D63"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 43,
    height: 36
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "0a7f729819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.09961 0H50.7149V35.904H8.09961V0Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.8036 27.9172L41.25 24.29L44.9107 21.6226L49.9144 17.973L44.8847 14.2863L40.1711 10.8265L35.186 7.17318L30.5878 3.79892L25.4241 0.0117188L20.4204 3.65755L16.7634 6.32496L11.7485 9.98196L8.4375 12.3964L13.6012 16.1836L16.9122 13.7692L21.9234 10.1122L25.5841 7.44476L30.186 10.819L35.1674 14.476L39.881 17.9321L36.4323 20.4507L36.224 20.5995L31.5067 17.1434L26.5253 13.4864L21.5104 17.1434L18.1994 19.5579L23.1845 23.2111L26.4955 20.8004L31.2091 24.2565L36.2351 27.9433L40.9859 31.4291L45.9152 35.0452L50.5283 31.6821L45.8036 27.9172Z",
    fill: "#110D63"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M78.9682 18.9288H69.8015V21.9496H78.5366C79.9057 21.9496 80.8283 22.184 81.3045 22.649C81.7881 23.1177 82.0337 23.9846 82.0337 25.2532V27.1728C82.0337 28.4526 81.7881 29.3268 81.3045 29.7919C80.8283 30.2606 79.9057 30.4913 78.5366 30.4913H69.8759C68.5069 30.4913 67.5768 30.2606 67.0932 29.7919C66.617 29.3268 66.3789 28.4526 66.3789 27.1728V26.8008L69.2509 26.1907V27.8573H79.1616V24.6579H70.4265C69.0649 24.6579 68.1423 24.4273 67.6587 23.9585C67.1825 23.4935 66.9444 22.6192 66.9444 21.3395V19.7919C66.9444 18.5233 67.1825 17.6564 67.6587 17.1877C68.1423 16.7227 69.0649 16.4883 70.4265 16.4883H78.373C79.6899 16.4883 80.5977 16.7115 81.0962 17.1579C81.6021 17.6044 81.8551 18.4042 81.8551 19.5538V19.8514L78.9682 20.521V18.9288Z",
    fill: "#110D63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M90.2859 28.2884H99.5419V21.1158H90.2859V28.2884ZM87.4883 21.711C87.4883 20.6694 87.6892 19.9625 88.0984 19.5831C88.5039 19.2073 89.2963 19.0176 90.4794 19.0176H99.3484C100.539 19.0176 101.331 19.2073 101.729 19.5831C102.135 19.9625 102.339 20.6694 102.339 21.711V27.7676C102.339 28.8204 102.131 29.5384 101.714 29.9253C101.305 30.3048 100.517 30.4908 99.3484 30.4908H90.4794C89.2963 30.4908 88.5039 30.3048 88.0984 29.9253C87.6892 29.5384 87.4883 28.8204 87.4883 27.7676V21.711Z",
    fill: "#110D63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M107.168 30.4908V19.0176H109.995V28.3479H118.983V30.4908H107.168Z",
    fill: "#110D63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M127.514 30.4908L120.564 19.0176H123.734L128.6 27.336L133.184 19.0176H136.085L129.434 30.4908H127.514Z",
    fill: "#110D63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M139.289 30.4908V19.0176H151.596V21.0414H142.116V23.5414H147.637V25.5206H142.116V28.3479H151.744V30.4908H139.289Z",
    fill: "#110D63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M155.785 30.4908V19.0176H168.092V21.0414H158.613V23.5414H164.133V25.5206H158.613V28.3479H168.241V30.4908H155.785Z",
    fill: "#110D63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M182.878 21.0712H174.992V23.4967H182.462C183.63 23.4967 184.419 23.6865 184.828 24.0622C185.233 24.4305 185.438 25.1411 185.438 26.1902V27.7676C185.438 28.8204 185.23 29.5384 184.813 29.9253C184.404 30.3048 183.622 30.4908 182.462 30.4908H175.006C173.823 30.4908 173.02 30.3048 172.596 29.9253C172.179 29.5384 171.971 28.8204 171.971 27.7676V27.4551L174.471 26.9938V28.3479H182.908V25.714H175.483C174.3 25.714 173.503 25.528 173.087 25.1485C172.67 24.7616 172.462 24.0473 172.462 23.0057V21.711C172.462 20.6805 172.67 19.9774 173.087 19.5979C173.503 19.211 174.3 19.0176 175.483 19.0176H182.283C183.444 19.0176 184.236 19.2036 184.664 19.5682C185.088 19.9365 185.304 20.5801 185.304 21.5027V21.7854L182.878 22.3063V21.0712Z",
    fill: "#110D63"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M194.607 30.4908V25.342L188.342 19.0176H192.122L196.214 23.2884L200.366 19.0176H203.654L197.404 25.2825V30.4908H194.607Z",
    fill: "#110D63"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 7612,
    fill: "white",
    transform: "translate(-72 -54)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 862,
    fill: "white",
    transform: "translate(-72 -54)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolveesy);
export default __webpack_public_path__ + "static/media/Solveesy.6801dd87a075b286233131cdaab29d10.svg";
export { ForwardRef as ReactComponent };